import styled from 'styled-components'

import { Typography } from '../../globals'

const StyledButton = styled.button`
  background-color: ${({ disabled, theme }) =>
    disabled ? '#cccccc' : theme.colors.primaryColor300};
  color: ${({ disabled }) => (disabled ? 'white' : 'black')};
  border: none;
  width: 40px;
  height: 35px;
  padding: 6px 12px;
  font-size: 16px;
  font-weight: 700;
  margin: 5px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  border-radius: 6px;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryColor100};
  }
`

type PaginationButtonProps = {
  label: string
  onClick: () => void
  disabled: boolean
}

const PaginationButton: React.FC<PaginationButtonProps> = (props) => {
  const { label, onClick, disabled } = props
  return (
    <StyledButton onClick={disabled ? undefined : onClick} disabled={disabled}>
      <Typography textAlign="center">{label}</Typography>
    </StyledButton>
  )
}

export default PaginationButton
